module.exports = __webpack_public_path__ + "img/course.3071a2ac.webp";